//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { IDataTypePanelRule, IMRDataTypePanelFormItemOptions, IMRDataTypePanelAdditionalOptions } from '../interfaces'

import { LocalizationHelper } from '../../../../helpers'

import { Enums } from "../../../../models/common"
import { OpDataType } from "../../../../models/core"


export class LatitudeLongitudeRule implements IDataTypePanelRule {


    //#region IDataTypePanelRule Implementation

    public canHandle(opDataType: OpDataType): JQueryPromise<boolean> {
        return $.Deferred<boolean>()
            .resolve(opDataType != null && (opDataType.idDataType === Enums.DataType.LOCATION_LATITUDE || opDataType.idDataType === Enums.DataType.LOCATION_LONGITUDE))
            .promise()
    }

    public getItemFormFieldOptions(opDataType: OpDataType, additionalOptions?: IMRDataTypePanelAdditionalOptions, isRequired?: boolean, data?: any[]): JQueryPromise<IMRDataTypePanelFormItemOptions> {
        if (opDataType != null) {
            const item: IMRDataTypePanelFormItemOptions = {
                template: '<location-select callback="$ctrl.onLocationSelected"></location-select>',

                dataField: opDataType.idDataType.toString(),
                validationRules: this.getDataTypeRuleOptions(opDataType, isRequired),

                label: {
                    location: 'top',
                    text: opDataType.toString()
                },
            }

            return $.Deferred().resolve(item).promise()
        }

        return $.Deferred().resolve(null).promise()
    }

    //#endregion


    //#region Private Methods

    private getDataTypeRuleOptions(opDataType: OpDataType, isRequired: boolean = false): any[] {
        const validationRules: any[] = []

        if (isRequired) {
            validationRules.push({
                type: 'required',
                message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.RequiredField)
            })
        }

        return validationRules
    }

    //#endregion

}